export const A2P_REGISTRATION_TYPE_STARTER = 1
export const A2P_REGISTRATION_TYPE_STANDARD = 2
